import Board from "../models/board";
import { apiResultSuccess, getWlogs } from "../apihelper";
import { WLog } from "../models/wlog";

export default class LogsController extends Board {
    constructor(
        id=-1, 
        title='', 
        type='', 
        orderIndex=-1,
        dateCreated='', 
        lastUpdated='', 
        hidden=false
    ) {
        super(parseInt(id), title, type, orderIndex, dateCreated, lastUpdated, hidden);

        this.logs = [];
        this.offset = 0;
        this.loadMoreIncrements = 10;
        this.loadingMore = false;
        this.hasMore = true;
    }

    getLogs() {
        return this.logs;
    }

    setLogs(newLogs=[]) {
        this.logs = newLogs;
    }

    getOffset() {
        return this.offset;
    }

    setOffset(newOffset=0) {
        this.offset = newOffset;
    }

    getHasMore() {
        return this.hasMore;
    }

    // API helper
    // Checks for success result
    // Upon success calls createLogs
    // Runs reload on subject
    handleAPIResult(results) {
        if ( apiResultSuccess(results) ) {
            if ( results.wLogs ) {
                const newLogs = results.wLogs
                const resultsLength = newLogs.length;

                if ( this.loadingMore ) {
                    this.createThenAppendNewLogs(newLogs);
                } else {
                    this.createLogs(newLogs);
                }

                this.offset = this.logs.length;
                this.hasMore = !(resultsLength < this.loadMoreIncrements);

                this.subject.runReload();
            }
        }
    }

    // Fetchs data by calling fetchLogs
    fetchData() {
        this.fetchLogs();
    }

    // Fetch habits data from API
    // When done call handleAPIResult fn
    fetchLogs() {
        getWlogs(
            (results) => {
                this.handleAPIResult(results);
            },
            this.id,
            this.offset
        )
    }

    // Refetch logs
    reloadData() {
        this.fetchData();
    }

    // Updates loadingMore state
    // Calls fetchLogs
    loadMore(animate=true) {
        this.loadingMore = true;
        this.fetchLogs();
    }

    // Iterates through newLogs
    // Creates a WLog for each
    // appends it to new array
    // Updates logs with new array
    createLogs(newLogs=[]) {
        const logs = [];

        newLogs.forEach(data => {
            const log = new WLog(data);
            logs.push(log);
        });

        this.setLogs(logs);
    }

    // Adds new log to the array of logs
    // Runs reload on subjet
    addNew(newData) {
        const newLog = new WLog(newData);
        newLog.animate = true;

        this.logs = [...this.logs, newLog];

        this.subject.runReload();
    }

    // Filters logs array by id
    // Assigns to logs
    // Notifies subject to reload
    delete(id=-1) {
        if ( id !== -1 ) {
            const newLogs = this.logs.filter(log => log.id !== id);
            this.setLogs(newLogs);
            this.subject.runReload();   
        }
    }

    // Create logs from array newLogs
    // Merge current logs and new logs arrays
    createThenAppendNewLogs(newLogs=[]) {
        const logs = [];

        newLogs.forEach(data => {
            const log = new WLog(data);
            logs.push(log);
        });

        this.logs = this.logs.concat(logs);
    }
}